export default __webpack_public_path__ + "static/media/baraka.572a7fff.webp";